var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-title"},_vm._l((_vm.titles),function(title,i){return _c('a',{staticClass:"nav-title__item",on:{"click":function($event){return _vm.goToItem(i)}}},[_vm._v(_vm._s(title.textContent))])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb5c3dfe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TheNavTitles.vue
// module id = bNO+
// module chunks = 1